import ShiplexLogo from '@/components/ui/ShiplexLogo';

import { Actions } from './components/Actions';
import { Breadcrumbs } from './components/Breadcrumbs';
import { SearchBar } from './components/SearchBar';
import { UserTile } from './components/UserTile';

export const Header: React.FC = () => {
  return (
    <header className="bg-secondary flex h-16 items-center justify-between border-0 shadow-sm 2xl:relative">
      <div className="ml-3 flex min-w-0 flex-1 items-center xl:ml-6">
        <div className="flex h-6 w-auto shrink-0 items-center">
          <ShiplexLogo color="duotoneWhite" className="h-6 w-auto" />
        </div>
        <Breadcrumbs />
      </div>
      <div className="w-65 shrink-0 2xl:absolute 2xl:left-1/2 2xl:w-100 2xl:-translate-x-1/2">
        <SearchBar />
      </div>
      <div className="flex shrink-0">
        <Actions />
        <UserTile />
      </div>
    </header>
  );
};
